export const convertUrlToFile = async (imageUrl, fileName) => {
  if (!imageUrl || typeof imageUrl !== "string") {
    throw new Error("Invalid image URL");
  }

  try {
    // Add a cache-busting timestamp
    const cacheBuster = new Date().getTime();
    const updatedImageUrl = `${imageUrl.replace(/\\\//g, "/")}?t=${cacheBuster}`;

    // Fetch the image from the URL
    const response = await fetch(updatedImageUrl);

    // Check if the request was successful
    if (!response.ok) {
      throw new Error(`Failed to fetch image: ${response.statusText}`);
    }

    // Convert the response to a Blob
    const blob = await response.blob();

    // Create a File object from the Blob
    return new File([blob], fileName, { type: blob.type });
  } catch (error) {
    console.error("Error in convertUrlToFile:", error);
    return null;
  }
};
